import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';



@Injectable()
export class memberPerkService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getAllPerks() {
    return this.authHttp.get("/api/members/perks").map(res =>{
      let value:any[] = [];
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  deletePerk(id: number){
    return this.authHttp.delete('/api/members/perks/'+id).map( res=> {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }
  
  createNewPerk(newPerk:any){
    return this.authHttp.post('/api/members/perks/new',newPerk).map( res=> {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    }); 
  }

  updatePerk(perk: any){
    return this.authHttp.put('/api/members/perks/update', perk).map(res =>{
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }
  




  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/memberPerk.service.ts